export default __webpack_public_path__ + "static/media/ic_refresh.7a0bb832.svg";